import { useState, useEffect } from "react";
import axios from "../../axiosConfig";
import { SinglePriceResponse } from "../../types/PricesTypes";

export const useGetSinglePrice = (id: string | undefined) => {
  const [data, setData] = useState<SinglePriceResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSinglePrice = async () => {
    if (!id) return;

    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`/prices/${id}`);
      setData(response.data);
    } catch (err: any) {
      setError(
        err.response?.data?.message || "Błąd podczas pobierania szczegółów ceny"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSinglePrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { data, loading, error, refetch: fetchSinglePrice };
};
